import { Component, Input } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

@Component({
  selector: 'ui-default-info-modal',
  templateUrl: './default-info-modal.component.html',
  styleUrls: ['./default-info-modal.component.scss'],
})
export class DefaultInfoModalComponent {
  @Input() infoHeader = 'info_modal.NoDataFound';
  @Input() infoTxt = '';
  @Input() infoIcon? = '';

  constructor(private modalCtrl: ModalController, navParams: NavParams) {
    this.infoTxt = this.infoTxt || navParams.get('infoTxt');
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }
}
